import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import Loader from '../Loader';
import { FaSearch } from "react-icons/fa";

const MpesaPullResult = () => {

  const [mpesaPullResult, setMpesaPullResult] = useState([]);
  const [searchMpesaPullResult, setSearchMpesaPullResult] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searched, setSearched] = useState(false);

  // Convert a date to partition format pYYYYMMDD
  const formatDateToPartition = (date) => {
    const d = new Date(date);
    return `p${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
  };


  // Fetch all mpesa pull result
  const getMpesapullresult = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      let query = `?transactionId=${searchMpesaPullResult}`

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Check if endDate is before startDate
        if (end < start) {
          alert('End date cannot be earlier than start date');
          setLoading(false);
          return;
        }
        
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays > 10) {
          alert('Date range cannot exceed 10 days');
          setLoading(false);
          return;
        }
        
        const partitions = [];
        let current = new Date(startDate);
        
        // Handle case when start and end are the same
        if (diffDays === 0) {
          let current = new Date(startDate);
          current.setDate(current.getDate() + 1);
          partitions.push(formatDateToPartition(current));
        } else {
          while (current <= end) {
            current.setDate(current.getDate() + 1);
            partitions.push(formatDateToPartition(current));
          }
        }
        
        query += `&partitions=${partitions.join(',')}`;
      }

      const response = await axios.get(`/payments/mpesa_pull_result${query}`);
      setMpesaPullResult(response.data.items);
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError('Network error! Check your connection.');
      } else if (error.response.status >= 500) {
        setError('Server error! Please try again later.');
      } else {
        setError('An unexpected error occurred!');
      }
    } finally {
      setLoading(false);
    }
  }, [searchMpesaPullResult, startDate, endDate]);

  // Handle search button click
  const handleSearch = () => {
    setSearched(true);
    getMpesapullresult();
  };

  // Handle clearing search inputs
  const handleClearSearch = () => {
    setSearchMpesaPullResult('');
    setStartDate('');
    setEndDate('');
    setMpesaPullResult([]); 
    setSearched(false); 
  };

  // Fetch data only if a search has been performed
  useEffect(() => {
    if (searched) getMpesapullresult();
  }, [searched, getMpesapullresult]);


  return (
    <div className='mx-auto p-4'>
      <h3 className="my-2"><b>Mpesa Pull Result</b></h3>
      <div className="bg-white rounded-lg p-4 w-full flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 py-2">
          <label htmlFor='search'><span className='hidden'>Search</span>
            <input
              type='search'
              id='search'
              className='px-3 py-1 w-full border bg-[#eef1ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              required
              placeholder='Search transaction...'
              value={searchMpesaPullResult}
              onChange={(e) => setSearchMpesaPullResult(e.target.value)}
            />
          </label>
          <label htmlFor="">
            <span className='hidden'>Start Date</span>
            <input 
              type="date"
              className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              value={startDate}
              onChange={(e) => {setStartDate(e.target.value)}}
            />
          </label>
          <label htmlFor="">
            <span className='hidden'>End Date</span>
            <input 
              type="date" 
              className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              value={endDate}
              onChange={(e) => {setEndDate(e.target.value)}}
            />
          </label>
          <button
            onClick={handleSearch}
            className='px-4 py-1 bg-[#2b1e3e] text-white rounded-md'
          >
            Search
          </button>
          <button
            onClick={handleClearSearch}
            className='px-4 py-1 bg-red-500 text-white rounded-md'
          >
            Clear
          </button>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#eef1ff] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#eef1ff] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          searched ? (
            <div className='overflow-x-auto rounded-lg'>
              {mpesaPullResult.length > 0
                ? (
                  <table className='w-full text-left table-auto'>
                    <thead>
                      <tr className='border-b border-slate-500'>
                        <th className='p-2'>Transaction Id</th>
                        <th className='p-2'>Phone Number</th>
                        <th className='p-2'>Amount</th>
                        <th className='p-2'>Organisaztion Name</th>
                        <th className='p-2'>Request ID</th>
                        <th className='p-2'>Sender</th>
                        <th className='p-2'>Status</th>
                        <th className='p-2'>Transaction Type</th>
                        <th className='p-2'>Transaction Date</th>
                        <th className='p-2'>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mpesaPullResult.map((mpesa) => (
                        <tr key={mpesa.request_id}>
                          <td className='p-2'>{mpesa.transactionId}</td>
                          <td className='p-2'>{mpesa.msisdn}</td>
                          <td className='p-2'>{mpesa.amount}</td>
                          <td className='p-2'>{mpesa.organizationname}</td>
                          <td className='p-2'>{mpesa.request_id}</td>
                          <td className='p-2'>{mpesa.sender}</td>
                          <td className='p-2'>{mpesa.status}</td>
                          <td className='p-2'>{mpesa.transactiontype}</td>
                          <td className='p-2'>{new Date(mpesa.trxDate).toLocaleString("en-CA", { hour12: false })}</td>
                          <td className='p-2'>{new Date(mpesa.date_created).toLocaleString("en-CA", { hour12: false })}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className='bg-[#eef1ff] text-[#134463] grid place-items-center h-[70vh]'>
                    <div className='grid place-items-center p-4'>
                      <h3><MdOutlineBlock /></h3>
                      <h4>No Data</h4>
                    </div>
                  </div>
                )}
            </div>
          ) : (
            <div className='grid place-items-center h-[70vh]'>
              <div className='text-[#134463] p-4'>
                <h3 className='flex items-center justify-center'><FaSearch /></h3>
                <h4>Search Mpesa Pull Result</h4>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MpesaPullResult;
